export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Jueves_eng.b93041a4.png";